import { formatLocaleNumber } from '@/utils/formatter';
import type {
    SubscriptionPaymentDto,
    SubscriptionPaymentStatus,
    SubscriptionStatus,
} from '@/types/subscription';

export const STATUS_LABEL: Record<SubscriptionStatus, string> = {
    trialing: '체험 중',
    active: '이용 중',
    past_due: '결제 실패',
    cancelled: '해지됨',
    expired: '만료됨',
};

export const PAYMENT_STATUS_LABEL: Record<SubscriptionPaymentStatus, string> = {
    pending: '대기',
    success: '결제 완료',
    failed: '실패',
    refunded: '환불됨',
};

export const REFUND_WINDOW_DAYS = 14;

/**
 * 환불 가능 여부 — status=success 이고 14일 이내.
 * 운영(production) 환경에서는 사용자에게 노출 X (개발/스테이징에서만 표시).
 */
export function isRefundable(payment: SubscriptionPaymentDto): boolean {
    if (payment.status !== 'success') return false;
    const created = new Date(payment.createdAt).getTime();
    if (Number.isNaN(created)) return false;
    const days = (Date.now() - created) / (1000 * 60 * 60 * 24);
    return days <= REFUND_WINDOW_DAYS;
}

/** production 빌드가 아니면 환불 UI 노출 */
export const SHOW_REFUND_UI = process.env.NODE_ENV !== 'production';

export function formatPrice(amount: number): string {
    return amount === 0 ? '무료' : `₩${formatLocaleNumber(amount)}`;
}

export function formatPriceWithPeriod(amount: number): string {
    return amount === 0 ? '무료' : `₩${formatLocaleNumber(amount)} / 월`;
}

/**
 * 사용량 row의 used/limit을 number로 안전 변환.
 * 백엔드가 BIGINT를 string으로 반환하므로 Number 캐스팅 필요.
 */
export function parseUsage(used: string | number, limit: string | number | null) {
    const usedN = typeof used === 'number' ? used : Number(used);
    const limitN = limit === null ? null : typeof limit === 'number' ? limit : Number(limit);
    const ratio = limitN === null || limitN === 0 ? 0 : Math.min(100, (usedN / limitN) * 100);
    return { used: usedN, limit: limitN, ratio };
}
